import React from 'react';
import { Article } from '../../Types/Article';
import { UserArticleQuizStage } from '../../Types/UserArticle';
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  XIcon,
} from 'react-share';
import { resolveAbsoluteAppUrl } from '../../Utils/Assets';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { AnalyticsEvent, useAnalytics } from '../../Context/AnalyticsProvider';

interface ShareArticleProps {
  article: Article | null;
}

const ShareArticle: React.FC<ShareArticleProps> = ({ article }) => {
  const { trackEvent } = useAnalytics();

  function generateShareUrl(platform: string) {
    const baseUrl = window.location.origin + window.location.pathname;
    return `${baseUrl}?utm_source=share&utm_medium=${platform}`;
  }

  return (
    <div className={`flex flex-col`}>
      <div
        className="
            flex flex-col md:p-3 xl:p-4 items-stretch gap-4
            max-sm:gap-1 max-sm:justify-between max-sm:p-4
            max-md:max-w-full
          "
      >
        <h3
          className="text-black text-xl font-medium
                max-sm:text-lg max-sm:font-bold
                max-md:max-w-full
            "
        >
          Share Your Story
        </h3>
        <div className="flex flex-col gap-2">
          <h4 className="text-gray-600 text-lg text-semibold">Share via</h4>
          <div className="flex flex-row gap-4 justify-center">
            <FacebookShareButton
              url={generateShareUrl('facebook')}
              onClick={() => {
                trackEvent(AnalyticsEvent.STORY_LINK_SHARED, {
                  articleId: article.id,
                  sharePlatform: 'facebook',
                });
              }}
            >
              <FacebookIcon size={48} round />
            </FacebookShareButton>
            <WhatsappShareButton
              url={generateShareUrl('whatsapp')}
              onClick={() => {
                trackEvent(AnalyticsEvent.STORY_LINK_SHARED, {
                  articleId: article.id,
                  sharePlatform: 'whatsapp',
                });
              }}
            >
              <WhatsappIcon size={48} round />
            </WhatsappShareButton>
            <TwitterShareButton
              url={generateShareUrl('twitter')}
              onClick={() => {
                trackEvent(AnalyticsEvent.STORY_LINK_SHARED, {
                  articleId: article.id,
                  sharePlatform: 'twitter',
                });
              }}
            >
              <XIcon size={48} round />
            </TwitterShareButton>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h4 className="text-gray-600 text-lg text-semibold">
            Or copy the link
          </h4>
          <div className="flex flex-row">
            <input
              type="text"
              disabled
              value={generateShareUrl('copyLink')}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <button
              className="bg-blue-500 text-white p-2 px-4 rounded-l-none rounded-r-lg"
              title="Copy"
              onClick={() => {
                navigator.clipboard.writeText(generateShareUrl('copyLink'));
                toast.success('Story link copied to clipboard');
                trackEvent(AnalyticsEvent.STORY_LINK_SHARED, {
                  articleId: article.id,
                  sharePlatform: 'copyLink',
                });
              }}
            >
              <FontAwesomeIcon icon={faCopy} className={`text-white`} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareArticle;
